import { buildTheme } from '../../shared/theme-builder';
import ascm from './index';

export default buildTheme(ascm.theme, ascm.variants);
